import { Room } from '@/core/models/room.model'
import { baseApi } from './base'
import { getSocket } from './socket'

export const roomApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmergencyRooms: builder.query<Room[], void>({
      query: () => `/emergency-rooms`,
      async onCacheEntryAdded(_arg, { cacheDataLoaded, cacheEntryRemoved, updateCachedData }) {
        const socket = await getSocket()
        const emergencyRoomActiveListener = (emergencyRoom: Room) => {
          updateCachedData((cachedEmergencyRooms) => {
            let found = false
            for (const cachedEmergencyRoom of cachedEmergencyRooms) {
              if (cachedEmergencyRoom._id !== emergencyRoom._id) continue
              Object.assign(cachedEmergencyRoom, emergencyRoom)
              found = true
              break
            }
            if (!found) cachedEmergencyRooms.push(emergencyRoom)
          })
        }
        const emergencyRoomInactiveListener = (emergencyRoom: Room) => {
          updateCachedData((cachedEmergencyRooms) => {
            const index = cachedEmergencyRooms.findIndex((cachedEmergencyRoom) => cachedEmergencyRoom._id === emergencyRoom._id)
            if (index !== -1) {
              cachedEmergencyRooms.splice(index, 1)
            }
          })
        }
        try {
          await cacheDataLoaded
          socket.on('emergency_room_active', emergencyRoomActiveListener)
          socket.on('emergency_room_inactive', emergencyRoomInactiveListener)
        } catch {
          // if cacheEntryRemoved resolved before cacheDataLoaded,
          // cacheDataLoaded throws
        }
        await cacheEntryRemoved
        socket.off('emergency_room_active', emergencyRoomActiveListener)
        socket.off('emergency_room_inactive', emergencyRoomInactiveListener)
      },
    }),
  }),
  overrideExisting: false,
})
